import { Component, Input, inject } from '@angular/core';
import { ModalRef, ConfirmationType, ConfirmationSource } from '@eg/ui';

@Component({
  selector: 'rmb-edit-booking-confirmation',
  templateUrl: './edit-booking-confirmation.component.html',
  styleUrls: ['./edit-booking-confirmation.component.scss'],
  standalone: false,
})
export class EditBookingConfirmationComponent {
  private modalRef = inject(ModalRef);

  @Input() type: ConfirmationType;
  @Input() source: ConfirmationSource;

  readonly TRANSLOCO_PREFIX = 'confirmation';

  onCloseClick(): void {
    this.modalRef.close();
  }

  onResponseClick(): void {
    this.modalRef.close();
  }
}
